import { render, staticRenderFns } from "./Lucky5_Express.vue?vue&type=template&id=0f4b693c&"
import script from "./Lucky5_Express.vue?vue&type=script&lang=js&"
export * from "./Lucky5_Express.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports